import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {fetchTag, resetTag} from '../../../creators/tag';
import {PageLoader} from "../../components/Loader";
import Medias from './components/Medias';
import Stories from "./components/Stories";
import createLink from "../../../libs/createLink";
import Articles from "./components/Articles";
import {Link} from "react-router-dom";
import {resetMediasTag} from "../../../creators/medias.tag";
import {resetArticlesTag} from "../../../creators/articles.tag";
import {resetStoriesTag} from "../../../creators/stories.tag";
import {canonical} from "../../../libs/helper";
import Helmet from "react-helmet";

class TagSearch extends React.Component {
    constructor(props) {
        super(props);
        this.typeTagKey = {
            "photo-sexe" : "gallery",
            "video-sexe" : "video",
            "histoire-de-sexe" : "story",
            "article-sexe" : "article",
            "error" : "error"
        };

        this.typeTag = (this.props.match && this.props.match.params && this.props.match.params.typeTag) || "error";
        this.state = {
            showAll : (this.props.match && this.props.match.params && this.props.match.params.all) || null,
            typeTag : this.typeTag,
            tagSlug : (this.props.match && this.props.match.params && this.props.match.params.tagSlug) || "",
            userSlug : (this.props.match && this.props.match.params && this.props.match.params.userSlug) || null,
            type :  this.typeTagKey[this.typeTag]
        };

        // this.type = this.typeTagKey[this.typeTag];
        // this.tagSlug = (this.props.match && this.props.match.params && this.props.match.params.tagSlug) || "";
        // this.userSlug = (this.props.match && this.props.match.params && this.props.match.params.userSlug) || null;
        // this.showAll = (this.props.match && this.props.match.params && this.props.match.params.all) || null;
        this.props.resetTag();
        this.props.fetchTag(this.state.tagSlug);
        this.metaHelmet = this.metaHelmet.bind(this);
    }


    componentWillUnmount(){
        this.props.resetTag();
        this.props.resetMediasTag();
        this.props.resetArticlesTag();
        this.props.resetStoriesTag();
    }


    shouldComponentUpdate(nextProps, nextState) {
        // console.log("props :",this.props.match.params.tagSlug, "Next :", nextProps.match.params.tagSlug, "Stat :", this.state.tagSlug, "Next :", nextState.tagSlug);
        // console.log(nextProps);
        // console.log(this.props.match.params.tagSlug, nextProps.match.params.tagSlug, this.state.tagSlug, nextState.tagSlug);
        if(this.props.match.params.all !== nextProps.match.params.all){
            this.setState({ showAll : (nextProps.match && nextProps.match.params && nextProps.match.params.all) || null});
        }
        // if(this.props.match.params.tagSlug !== nextProps.match.params.tagSlug && this.state.tagSlug !== nextState.tagSlug){
        //     let tagSlug = (nextProps.match && nextProps.match.params && nextProps.match.params.tagSlug) || "";
        //     console.log(tagSlug);
        //     this.setState({ tagSlug}, ()=> this.props.fetchTag(tagSlug));
        // }
        if(this.props.match.params.tagSlug !== nextProps.match.params.tagSlug){
            let tagSlug = (nextProps.match && nextProps.match.params && nextProps.match.params.tagSlug) || "";
            this.props.fetchTag(tagSlug);
            this.setState({ tagSlug});
        }
        if(this.props.match.params.userSlug !== nextProps.match.params.userSlug){
            this.setState({ userSlug : (nextProps.match && nextProps.match.params && nextProps.match.params.userSlug) || null});
        }
        if(this.props.match.params.typeTag !== nextProps.match.params.typeTag){
            let typeTag = (nextProps.match && nextProps.match.params && nextProps.match.params.typeTag) || "error";
            this.setState({ typeTag, type :  this.typeTagKey[typeTag]});
        }
        return true;
    }


    h3TagLink() {
        let links = {
            story: <h3>
                <Link to={createLink("tagVideo", {tag: this.props.tag, slug : this.state.userSlug})} className="">vidéos</Link>
                <Link to={createLink("tagPhoto", {tag: this.props.tag, slug : this.state.userSlug})} className="">photos</Link>
                <Link to={createLink("tagArticle", {tag: this.props.tag, slug : this.state.userSlug})} className="">articles</Link>
                <Link to={createLink("tagStory", {tag: this.props.tag, slug : this.state.userSlug})} className="active">histoires</Link>
            </h3>,
            video: <h3>
                <Link to={createLink("tagVideo", {tag: this.props.tag, slug : this.state.userSlug})} className="active">vidéos</Link>
                <Link to={createLink("tagPhoto", {tag: this.props.tag, slug : this.state.userSlug})} className="">photos</Link>
                <Link to={createLink("tagArticle", {tag: this.props.tag, slug : this.state.userSlug})} className="">articles</Link>
                <Link to={createLink("tagStory", {tag: this.props.tag, slug : this.state.userSlug})} className="">histoires</Link>
            </h3>,
            gallery: <h3>
                <Link to={createLink("tagVideo", {tag: this.props.tag, slug : this.state.userSlug})} className="">vidéos</Link>
                <Link to={createLink("tagPhoto", {tag: this.props.tag, slug : this.state.userSlug})} className="active">photos</Link>
                <Link to={createLink("tagArticle", {tag: this.props.tag, slug : this.state.userSlug})} className="">articles</Link>
                <Link to={createLink("tagStory", {tag: this.props.tag, slug : this.state.userSlug})} className="">histoires</Link>
            </h3>,
            article: <h3>
                <Link to={createLink("tagVideo", {tag: this.props.tag, slug : this.state.userSlug})} className="">vidéos</Link>
                <Link to={createLink("tagPhoto", {tag: this.props.tag, slug : this.state.userSlug})} className="">photos</Link>
                <Link to={createLink("tagArticle", {tag: this.props.tag, slug : this.state.userSlug})} className="active">articles</Link>
                <Link to={createLink("tagStory", {tag: this.props.tag, slug : this.state.userSlug})} className="">histoires</Link>
            </h3>
        };
        return links[this.state.type] || null;
    }

    metaHelmet() {
        let metaDefault = {
            story: {
                title : `Histoire de sexe : ${this.state.tagSlug} - Voissa`,
                description : `Découvrez les ✎ histoires ${this.state.tagSlug} ✎ érotiques et de sexe, ❤réelles ou fantasmées❤ par les Voissanautes, pour inspirer votre désir !`
            },
            video: {
                title : `${this.state.tagSlug} : Vidéo Sexe Amateur sur Voissa`,
                description : `Les ✔ meilleures vidéos de ${this.state.tagSlug} ✔ sur Voissa. Tous les jours des nouvelles vidéos ★ 100% français. ★`
            },
            gallery: {
                title : `${this.state.tagSlug} : Photo Sexe Amateur sur Voissa`,
                description : `Les ✔ meilleures photos de ${this.state.tagSlug} ✔ sur Voissa. Tous les jours des nouvelles contributions photos d’amatrices ★ 100% français. ★`
            },
            article: {
                title : `${this.state.tagSlug}: Blog Sexe Amateur sur Voissa`,
                description : `Découvrez les articles de ✎  ❤ ${this.state.tagSlug} ✎  ❤ publiés sur les blogs amateur de Voissa et suivez au quotidien les exhibs et contributions des amatrices.`
            }
        };
        if(this.props.tag && this.props.tag.title){
            metaDefault = {
                story: {
                    title : `Histoire de sexe : ${this.props.tag.title} - Voissa`,
                    description : `Découvrez les ✎ histoires ${this.props.tag.title} ✎ érotiques et de sexe, ❤réelles ou fantasmées❤ par les Voissanautes, pour inspirer votre désir !`
                },
                video: {
                    title : `${this.props.tag.title} : Vidéo Sexe Amateur sur Voissa`,
                    description : `Les ✔ meilleures vidéos de ${this.props.tag.title} ✔ sur Voissa. Tous les jours des nouvelles vidéos ★ 100% français. ★`
                },
                gallery: {
                    title : `${this.props.tag.title} : Photo Sexe Amateur sur Voissa`,
                    description : `Les ✔ meilleures photos de ${this.props.tag.title} ✔ sur Voissa. Tous les jours des nouvelles contributions photos d’amatrices ★ 100% français. ★`
                },
                article: {
                    title : `${this.props.tag.title} : Blog Sexe Amateur sur Voissa`,
                    description : `Découvrez les articles de ✎  ❤ ${this.props.tag.title} ✎  ❤ publiés sur les blogs amateur de Voissa et suivez au quotidien les exhibs et contributions des amatrices.`
                }
            };
        }

        return metaDefault[this.state.type] || null;
    }

    render() {
        return <div id="tag-search">
            <div className="container">
                <div className="card big">
                    {!this.props.tagInitialized && (
                        <PageLoader/>
                    )}
                    {!this.props.tagLoading && !this.props.tag && (
                        <Fragment>
                            <Helmet>
                                <title>{this.metaHelmet().title }</title>
                                <meta name="description" content={this.metaHelmet().description } />
                                <link rel="canonical" href={canonical(this.props.location.pathname)} />
                                <meta name="robots" content="noindex" />
                            </Helmet>
                            <h2>Aucun tag excitant pour cette recherche</h2>
                        </Fragment>
                    )}
                    {!this.props.tagLoading && this.props.tag && this.props.tag._id && (
                        <Fragment>
                            <div className="card-controls">
                                <div className="main-controls-row"><h1 className="head-title  display-2">Recherche "{this.props.tag && this.props.tag.title}"</h1></div>
                                <div className="sub-controls-row">
                                        {this.h3TagLink()}
                                </div>
                            </div>
                            {(this.state.type === "video" || this.state.type === "gallery") && (<Medias {...this.props} metaHelmet={this.metaHelmet} key={`media${this.state.showAll}_${this.state.userSlug}_${this.props.tag}_${this.state.type}_${this.state.tagSlug}`} type={this.state.type} tag={this.props.tag} slugUser={this.state.userSlug} showAll={this.state.showAll} />)}
                            {this.state.type === "story"  && (<Stories {...this.props} metaHelmet={this.metaHelmet} key={`story${this.state.showAll}_${this.state.userSlug}_${this.props.tag}_${this.state.tagSlug}`}  tag={this.props.tag} slugUser={this.state.userSlug} showAll={this.state.showAll} />)}
                            {this.state.type === "article"  && (<Articles {...this.props} metaHelmet={this.metaHelmet} key={`article${this.state.showAll}_${this.state.userSlug}_${this.props.tag}_${this.state.tagSlug}`} tag={this.props.tag} slugUser={this.state.userSlug} showAll={this.state.showAll} />)}
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    }
}


const mapStateToProps = (state) => {
    return {
        currentUserInitialized: state.currentUser.initialized,
        tag : state.tag.data,
        tagInitialized : state.tag.initialized,
        tagLoading : state.tag.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTag,
    resetTag,
    resetMediasTag,
    resetArticlesTag,
    resetStoriesTag
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(TagSearch);
